export { VisitsPageV2 } from './visits-page-v2';
